import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import logo from "../../images/new_logo.svg";
import equalHousingLogo from "../../images/Equal_Housing_Opportunity.png";
import { connect } from "react-redux";
import Show from "../../utils/show.component";
import { hideModal, showModal } from "../../actions/modal.actions";
import { restartApp } from "../../actions/appRestart.actions";
import { resumeApp } from "../../actions/appStatus.actions";
import ContentHeader from "../content-header/content-header.component.js";
import ModalOverlay from "../modal/modal.component";
import PopupModal from "../popupModal/popupModal.component";
import ConfirmationModal from "../confirmationModal/confirmation-modal.component";
import NotificationBar from "../notification-bar/notification-bar.component";
import AutoPayModal from "../autopay-modal/component";
import { getWebsiteUrl } from "../../utils/content";
import olbImage from "../../images/OLB-Image.png";
import googlePlayBadge from "../../images/google-play.svg";
import appStoreBadge from "../../images/app-store.svg";
import { getEnrollmentUrl } from "../../utils/content";
export class AppComponent extends Component {
  constructor(props) {
    super(props);
    this.restartApp = this.restartApp.bind(this);
    this.resumeAppAndCloseModal = this.resumeAppAndCloseModal.bind(this);
  }

  restartApp() {
    this.props.restartApp();
    window.location.href = "/";
  }

  resumeAppAndCloseModal() {
    this.props.resumeApp();
    this.props.hideModal();
  }

  render() {
    const wrapperMinHeight = this.props.appStatus.showLogoAndFooter
      ? "calc(100vh - 215px)"
      : "calc(100vh)";

    const oneTimePaymentRoutes = ["/", "/loan-info", "/loan-payment", "/loan-review"];

    const isOneTimePaymentsFlow = oneTimePaymentRoutes.includes(this.props.location.pathname);

    const contentContainerClass = isOneTimePaymentsFlow
      ? "col-12 col-lg-8 left-content-column"
      : "col-12";
    return (
      <div className="LoanPayments">
        {/* Global Header */}
        <Show condition={this.props.appStatus.showLogoAndFooter}>
          <header>
            <div class="wrapper flex-row">
              <img
                class="logo"
                src={logo}
                style={{ width: "220px" }}
                alt="Lake Trust Credit Union"
              />
            </div>
          </header>
        </Show>
        {/* Notification bar for errors or other generic notifications */}
        <NotificationBar
          show={this.props.notification.show}
          message={this.props.notification.message}
          notificationType={this.props.notification.notificationType}
        />
        {/* Loading modal overlay */}
        <ModalOverlay
          message={this.props.modal.message}
          show={this.props.modal.type === "loading"}
          complete={this.props.modal.complete}
        />
        {/* Pop up modal (not full overlay) */}
        <ConfirmationModal
          show={["confirmation", "cancel"].indexOf(this.props.modal.type) > -1}
          modalType={this.props.modal.type}
          message={this.props.modal.message}
          buttonText={this.props.modal.buttonText}
          hideModal={this.props.modal.type === "cancel" ? this.props.hideModal : this.restartApp}
          confirm={
            this.props.modal.type === "cancel" ? this.restartApp : this.resumeAppAndCloseModal
          }
        />
        {/* Pop up modal (not full overlay) */}
        <div className="px-1">
          <PopupModal
            show={this.props.modal.type === "popup"}
            heading={this.props.modal.heading}
            message={this.props.modal.message}
            buttonUrl={this.props.modal.buttonUrl}
            buttonText={this.props.modal.buttonText}
            icon={this.props.modal.icon}
            hideModal={this.props.hideModal}
          />
        </div>
        <AutoPayModal show={this.props.modal.type === "autopay"} hideModal={this.props.hideModal} />
        {/*Main Content area where all components will be displayed*/}
        <div
          className="app-wrapper"
          style={{
            backgroundColor: this.props.appStatus.bgColor,
            minHeight: wrapperMinHeight,
          }}
        >
          <div className="container">
            <div className="row">
              <div className={contentContainerClass}>
                <ContentHeader
                  show={this.props.appStatus.header}
                  showProgressBar={!this.props.appStatus.processComplete}
                  headerTitle={this.props.appStatus.headerTitle}
                  headerContent={this.props.appStatus.headerContent}
                />
                <div className="row">
                  <div className="col-12">{this.props.children}</div>
                  <div className="col-12">
                    {/* Cancel loan payment button */}
                    <a
                      href="#"
                      className={
                        this.props.processSteps.currentStep != 1 &&
                        !this.props.appStatus.processComplete
                          ? "cancel-link"
                          : "hide"
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        window.scrollTo(0, 0);
                        this.props.showModal(
                          "cancel",
                          "Are you sure you would like to cancel this payment?"
                        );
                      }}
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
              {isOneTimePaymentsFlow && (
                <div className="col-12 col-lg-4 right-sidebar-column">
                  <div className="container">
                    {/* Static Content Sidebar */}
                    <div className="olb-enroll-ad">
                      <h2 className="color-white">
                        Payments are so much easier with online banking
                      </h2>
                      <p className="color-white">
                        Sign up today to set up AutoPay, receive due date alerts, process skip-a-pay
                        on your loan, and view your loan information and payment history.
                      </p>
                      <div>
                        <a
                          href={getEnrollmentUrl()}
                          className="color-white f16"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Enroll now
                        </a>
                      </div>
                      <div className="d-flex justify-content-center my-3">
                        <img
                          src={olbImage}
                          alt="Enroll in Online Banking"
                          className="responsive-image"
                        />
                      </div>
                      <p className="color-white">
                        Download the Lake Trust mobile app for fast and convenient banking on the
                        go.
                      </p>
                      <div className="d-flex">
                        <div>
                          <a
                            href="https://apps.apple.com/us/app/lake-trust-mobile-banking/id6480133579?itscg=30200&itsct=apps_box_badge&mttnsubad=6480133579"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={appStoreBadge}
                              alt="Download on the App Store"
                              height={"35"}
                            />
                          </a>
                        </div>
                        <div className="ml-3">
                          <a
                            href="https://play.google.com/store/apps/details?id=com.laketrustcreditunion.app"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={googlePlayBadge} alt="Get it on Google Play" height={"35"} />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Global Footer */}
        <Show condition={this.props.appStatus.showLogoAndFooter}>
          <footer>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <a target="_blank" href={`${getWebsiteUrl()}/disclosures`}>
                    Disclosures
                  </a>
                  <a target="_blank" href={`${getWebsiteUrl()}/privacy`}>
                    Privacy
                  </a>
                  <a target="_blank" href={`${getWebsiteUrl()}/locations`}>
                    Locations
                  </a>
                  <a target="_blank" href={`${getWebsiteUrl()}/personal/contact-us`}>
                    Contact
                  </a>
                  <p>
                    &copy; 2024. Lake Trust Credit Union - All Rights Reserved. Federally Insured by
                    NCUA. <br />
                    <img
                      src={equalHousingLogo}
                      class="equal-housing"
                      alt="Equal Housing Opportunity"
                    />
                  </p>
                </div>
              </div>
            </div>
          </footer>
        </Show>
      </div>
    );
  }
}

// Map global store to component props
const mapStateToProps = (state) => state;

// Hook up actions to component
const mapDispatchToProps = {
  hideModal,
  showModal,
  restartApp,
  resumeApp,
};

//Connect to Redux store
const App = withRouter(connect(mapStateToProps, mapDispatchToProps)(AppComponent));

export default App;



// WEBPACK FOOTER //
// ./src/components/app-wrapper/app-wrapper.component.js